{
  "0_ALREADY_EXISTS": "\"{0}\" はすでに存在します。",
  "0_OF_1": "{1}中の{0}",
  "ACCOUNT_ID": "アカウントID",
  "ADD": "追加",
  "ADD_REMOVE_FIELDS": "フィールドの追加/削除",
  "AN_ERROR_OCCURED": "エラーが発生しました",
  "APPLY": "適用",
  "APPLY_CHANGES": "変更を適用",
  "ATTACH": "添付",
  "ATTACH_AS_LINK": "リンクとして添付",
  "ATTACHING": "添付中...",
  "AUTOMATICALLY_RENAME": "自動的に名前を変更",
  "BACK": "戻る",
  "BROWSE": "参照",
  "CANCEL": "キャンセル",
  "CHARACTER_COUNT": "文字数:",
  "CLOSE": "閉じる",
  "CLOUD": "Cloud",
  "COMMENT": "コメント",
  "CONFIGURE_REPOSITORY_SETTINGS": "リポジトリ設定の構成",
  "COULD_NOT_SAVE_0": "\"{0}\" を保存できませんでした。",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "\"{0}\" を保存できませんでした。ファイル形式はサポートされていません。",
  "DATA": "データ",
  "DATE": "日付",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "日付フィールドは {0} の形式でなければなりません。",
  "DATE_PROVIDED_IS_INVALID": "指定された日付が無効です。",
  "DATE_TIME": "日付/時刻",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "日付/時刻フィールドは {0} の形式でなければなりません。",
  "DEFAULT_FOLDER": "<既定のフォルダー>",
  "DETAILS": "詳細",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "フィールドの変更を適用しますか？",
  "DOCUMENT_NAME_IS_EMPTY": "ドキュメント名が空です",
  "DRAG_DROP_FILE": "ファイルをドラッグアンドドロップ",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "このフォルダーには '{0}' という名前のエントリが既に存在します。別の名前を選択してください。",
  "ENTRY_ID": "エントリID",
  "ENTRY_NAME": "エントリ名",
  "ENTRY_NOT_FOUND": "エントリが見つかりません。",
  "ERROR_DOWNLOADING_DOCUMENT": "ドキュメントのダウンロード中にエラーが発生しました。",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "サーバーへの接続中にエラーが発生しました。",
  "ERROR_SAVING": "保存エラー:",
  "FAILED_TO_OPEN_FOLDER": "フォルダーを開くことができませんでした",
  "FAILED_TO_SAVE_COLON": "保存に失敗しました:",
  "FAILED_TO_SAVE_PERIOD": "保存に失敗しました。",
  "FEEDBACK": "フィードバック",
  "FIELDS": "フィールド",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "このファイルは最大ファイルサイズ25MBを超えています。",
  "FILE_EXTENSION": "ファイル拡張子",
  "FILE_LOCKED": "ファイルはロックされています。",
  "FILE_MODIFIED": "ファイルが変更されました",
  "FILE_NAME": "ファイル名",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "ファイル名にバックスラッシュを含めることはできません",
  "FOLDER": "フォルダー",
  "INTEGER": "整数",
  "LIST": "リスト",
  "LOADING": "読み込み中...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "ロングフィールドは0から3,999,999,999の間の整数でなければなりません",
  "LONG_INTEGER": "長整数",
  "NAME": "名前",
  "NAME_CONFLICT": "名前の競合",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "サインインに問題がありますか？Laserfiche 管理者にお問い合わせください。",
  "NEW_FOLDER": "新しいフォルダー",
  "NO": "いいえ",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "追加のフィールドが割り当てられていません",
  "NO_FOLDER_SELECTED": "フォルダーが選択されていません。",
  "NO_MATCHING_ENTRIES_FOUND": "一致するエントリが見つかりませんでした",
  "NO_MATCHING_FIELDS_FOUND": "一致するフィールドが見つかりませんでした。",
  "NO_TEMPLATE_ASSIGNED": "テンプレートが割り当てられていません",
  "NOT_AVAILABLE_WITH_TOKENS": "トークンでは利用できません",
  "NUMBER": "数値",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "数値フィールドは有効な数値でなければなりません",
  "OK": "OK",
  "ONE_OR_MORE_FIELDS_INVALID": "1つ以上のフィールドが無効です。",
  "OPEN": "開く",
  "OPEN_IN_LASERFICHE": "Laserfiche で開く",
  "OPTIONAL": "任意",
  "OR": "または",
  "PARENT_FIELD": "親フィールド",
  "PARENT_ID": "親ID",
  "PARENT_NAME": "親の名前",
  "PLEASE_SELECT_A_FOLDER": "フォルダーを選択してください",
  "REASON_FOR_DOWNLOADING": "ダウンロードの理由",
  "REFRESH": "更新",
  "REMOVE": "削除",
  "REMOVE_REPOSITORY": "リポジトリを削除しますか？",
  "REPOSITORY": "リポジトリ",
  "REPOSITORY_COUNT": "リポジトリ数",
  "REPOSITORY_ID": "リポジトリID",
  "REPOSITORY_NAME": "リポジトリ名",
  "REQUIRED": "必須",
  "REQUIRED_FIELD_IS_EMPTY": "必須フィールドが空です",
  "SAVE_CHANGES": "変更を保存",
  "SAVE_TO_LASERFICHE": "Laserfiche に保存",
  "SAVED_TO_LASERFICHE": "Laserfiche に保存されました",
  "SAVED_TO_LASERFICHE_COLON": "Laserfiche に保存されました:",
  "SAVED_WITH_MISSING_METADATA": "メタデータが不足したまま保存されました:",
  "SAVING": "保存中...",
  "SEARCH_FIELDS": "検索フィールド",
  "SELECT": "選択",
  "SELECT_REASON": "理由を選択してください",
  "SELF_HOSTED": "セルフホスト",
  "SESSION_COUNT": "セッション数",
  "SETTINGS": "設定",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "ショートフィールドは0から64999の間の整数でなければなりません",
  "SIGN_IN": "サインイン",
  "SIGN_IN_TO_LASERFICHE": "Laserfiche にサインイン",
  "SIGN_OUT": "サインアウト",
  "SIGNING_IN": "サインイン中...",
  "SIGNING_OUT": "サインアウト中...",
  "SKIP_THIS_FILE": "このファイルをスキップ",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "問題が発生しました。後でもう一度お試しください。",
  "SUBMIT": "送信",
  "SUGGESTION": "提案",
  "TEMPLATE": "テンプレート",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "テンプレートの読み込みに失敗しました。",
  "TEXT": "テキスト",
  "THANK_YOU_FOR_SUBMISSION": "ご提出ありがとうございます！",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "このフィールドの最大許容長は {0} 文字です。",
  "THIS_FOLDER_IS_EMPTY": "このフォルダーは空です。",
  "TIME": "時刻",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "時間フィールドは形式 {0} でなければなりません。",
  "UNABLE_TO_LOAD_ALL_FIELDS": "すべてのフィールドを読み込めません:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "リポジトリ情報を取得できません:",
  "UNKNOWN_ERROR": "不明なエラーです。",
  "USER_NAME": "ユーザー名",
  "YES": "はい"
}
